import { render, staticRenderFns } from "./DistributorForm.vue?vue&type=template&id=1e55360e&scoped=true"
import script from "./DistributorForm.vue?vue&type=script&lang=js"
export * from "./DistributorForm.vue?vue&type=script&lang=js"
import style0 from "./DistributorForm.vue?vue&type=style&index=0&id=1e55360e&prod&scoped=true&lang=css"
import style1 from "./DistributorForm.vue?vue&type=style&index=1&id=1e55360e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e55360e",
  null
  
)

export default component.exports